/* eslint-disable vars-on-top */
/* eslint-disable no-redeclare */

/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
(function () {
  var isIe = /(trident|msie)/i.test(navigator.userAgent);

  if (isIe && document.getElementById && window.addEventListener) {
    window.addEventListener(
      'hashchange',
      function () {
        var id = location.hash.substring(1),
          element;

        if (!/^[A-z0-9_-]+$/.test(id)) {
          return;
        }

        element = document.getElementById(id);

        if (element) {
          if (!/^(?:a|select|input|button|textarea)$/i.test(element.tagName)) {
            element.tabIndex = -1;
          }

          element.focus();
        }
      },
      false
    );
  }
})();

(function ($) {
  // Controls the Back to Top Function
  // ---------------------------------------------------------------
  $(document).ready(function () {
    $('#back_top').click(function (event) {
      event.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 'slow');
      return false;
    });
  });

  // Controls when the Back to Top Div shows
  // ---------------------------------------------------------------
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();
    if (200 <= scroll) {
      $('#back_top').css('display', 'block');
    } else {
      $('#back_top').css('display', 'none');
    }
  });

  // Add animation to the Fabric Selector page when it changes
  // ---------------------------------------------------------------
  var i = 0;
  $('.fabric_box').each(function () {
    $(this).css('--animation-order', i);
    i++;
  });

  $(document).ready(function () {
    const swiper = new Swiper('.swiper', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      simulateTouch: false,

      autoplay: {
        delay: 5000,
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    swiper.on('slideChangeTransitionEnd', function () {
      $('.swiper-slide').each(function () {
        $(this).find('.home_slider_box').removeClass('active_slide');

        if ($(this).hasClass('swiper-slide-active')) {
          $(this).find('.home_slider_box').addClass('active_slide');
        }
      });
    });
  });

  $(document).ready(function () {
    const swipercol = new Swiper('.swipercol', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      simulateTouch: false,
      slidesPerView: 3,
      spaceBetween: 0,

      autoplay: {
        delay: 5000,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  $(document).ready(function () {
    new Swiper('.swiper_education', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      simulateTouch: false,

      autoplay: {
        delay: 5000,
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  $(document).ready(function () {
    const swipercol = new Swiper('.swiperInspiration', {
      // Optional parameters
      direction: 'horizontal',
      loop: true,
      simulateTouch: false,
      slidesPerView: 1,
      breakpoints: {
        1200: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
      },
      spaceBetween: 20,

      autoplay: {
        delay: 5000,
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  });

  // Runs the Timeline clicks on the About Page
  // ---------------------------------------------------------------------------
  $('.about_timeline_wrap ul li a').click(function (event) {
    event.preventDefault();
    $('.timeline_active').removeClass('timeline_active');
    $(this).addClass('timeline_active');

    var timeline = $(this).data('timeline');
    $('.about_timeline_wrap')
      .find('.timeline_row_active')
      .removeClass('timeline_row_active');
    $(timeline).addClass('timeline_row_active');
  });

  // Runs the Video Overlay click on the About Page
  // ---------------------------------------------------------------------------
  $('.video_btn').click(function (event) {
    event.preventDefault();

    var videoID = $(this).data('video');
    $('.popup_iframe').attr('src', videoID);
  });

  $('.modal__close').click(function (event) {
    event.preventDefault();
    $('.popup_iframe').attr('src', null);
  });

  // Click on the mobile navigation
  // ---------------------------------------------------------------------------
  // $('.pushy-submenu').click(function (event) {
  //   if (!$(this).hasClass('clicked')) {
  //     $('.pushy-submenu').removeClass('clicked');
  //     event.preventDefault();
  //     $(this).addClass('clicked');
  //   }
  // });

  // Controls the Accordion Click
  // -----------------------------------------------------------------
  if (0 < $('.accordion-container').length) {
    new Accordion('.accordion-container', {
      duration: 400,
      showMultiple: true,
    });
  }

  // Controls the Mobile Btn Click
  // -----------------------------------------------------------------
  if (0 < $('.mobile-button').length) {
    var btn1 = document.getElementById('mobile-button');
    btn1.addEventListener('click', function () {
      btn1.classList.toggle('cross');
    });
  }

  // Script for the Load Move on the Media Page
  // -----------------------------------------------------------------
  $('.youtubeVideoPlayer').each(function (index) {
    if (3 < index) {
      $(this).css('display', 'none');
    }
  });

  // Controls the Click on the Load More Button on the Media Page
  // ---------------------------------------------------------------------------
  $('#videoLoadMore').click(function (event) {
    event.preventDefault();
    $('.youtubeVideoPlayer').css('display', 'block');
    $(this).css('display', 'none');
  });

  // Controls the Click on the Product Gallery Image Button
  // ---------------------------------------------------------------------------
  // $('.product_gallery_image_button').click(function (event) {
  //   event.preventDefault();
  //   $('#main_product_image').attr('src', $(this).data('url'));
  // });

  // Select all links with hashes
  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function (event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') ==
          this.pathname.replace(/^\//, '') &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length
          ? target
          : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate(
            {
              scrollTop: target.offset().top,
            },
            1000,
            function () {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(':focus')) {
                // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              }
            }
          );
        }
      }
    });
})(jQuery);

// Initialize the Micro Modal for the site
// ---------------------------------------------------------------------------
MicroModal.init();

// Controls the YouTube Function on the site with the shortcode
// ---------------------------------------------------------------------------
document.addEventListener('DOMContentLoaded', function () {
  var div,
    n,
    v = document.getElementsByClassName('youtube-player');
  for (n = 0; n < v.length; n++) {
    div = document.createElement('div');
    div.setAttribute('data-id', v[n].dataset.id);
    div.innerHTML = labnolThumb(v[n].dataset.id);
    div.onclick = labnolIframe;
    v[n].appendChild(div);
  }
});

function labnolThumb(id) {
  var thumb = '<img src="https://i.ytimg.com/vi/ID/maxresdefault.jpg">',
    play = '<div class="play"></div>';
  return thumb.replace('ID', id) + play;
}

function labnolIframe() {
  var iframe = document.createElement('iframe');
  var embed = 'https://www.youtube.com/embed/ID?autoplay=1';
  iframe.setAttribute('src', embed.replace('ID', this.dataset.id));
  iframe.setAttribute('allow', 'autoplay');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', '1');
  this.parentNode.replaceChild(iframe, this);
}

(function ($) {
  // Fabric Search
  $('#fabricSearch').on('change', function (e) {
    e.preventDefault();

    // Get each color selected and add it to an Array
    // Then convert Array to String
    var colors = [];
    $('input[name="color"]:checked').each(function () {
      colors.push(this.value);
    });
    var colorString = colors.toString();

    // Get each color selected and add it to an Array
    // Then convert Array to String
    var collection = [];
    $('input[name="collection"]:checked').each(function () {
      collection.push(this.value);
    });
    var collectionString = collection.toString();

    // Get each color selected and add it to an Array
    // Then convert Array to String
    var manu = [];
    $('input[name="manufacturers"]:checked').each(function () {
      manu.push(this.value);
    });
    var manufacturerString = manu.toString();

    var currentSearch = [...colors, ...collection, ...manu];

    $('.current_filter').empty();
    for (var i = 0; i < currentSearch.length; ++i) {
      var element = currentSearch[i];

      $('.current_filter').append('<li>' + element + '</li>');
    }

    var data = {
      action: 'loadmore',
      _ajax_nonce: owlee_loadmore_params.nonce,
      postType: 'fabrics',
      color: colorString,
      collection: collectionString,
      manufacturers: manufacturerString,
    };

    console.log(data);

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      data: data,
      type: 'POST',

      success: function (data) {
        if (data) {
          $('.fabric_row').empty();
          $('.fabric_row').append(data);
        } else {
          $('.fabric_row').empty();
          $('.fabric_row').append(
            '<div class="error">No fabrics match your search criteria. Try a something different.</div>'
          );
        }
      },
    });
  });

  // Fabric Search
  $('#tilesSearch').on('change', function (e) {
    e.preventDefault();

    // Get each color selected and add it to an Array
    // Then convert Array to String
    var tileTypes = [];
    $('input[name="tile_type"]:checked').each(function () {
      tileTypes.push(this.value);
    });
    var tileTypeString = tileTypes.toString();

    var currentSearch = [...tileTypes];

    $('.current_filter').empty();
    for (var i = 0; i < currentSearch.length; ++i) {
      var element = currentSearch[i];

      $('.current_filter').append('<li>' + element + '</li>');
    }

    var data = {
      action: 'loadmore',
      _ajax_nonce: owlee_loadmore_params.nonce,
      postType: 'tiles',
      tileType: tileTypeString,
    };

    console.log(data);

    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      data: data,
      type: 'POST',

      success: function (data) {
        if (data) {
          $('.fabric_row').empty();
          $('.fabric_row').append(data);
        } else {
          $('.fabric_row').empty();
          $('.fabric_row').append(
            '<div class="error">No tiles match your search criteria. Try a something different.</div>'
          );
        }
      },
    });
  });
})(jQuery);
